var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferArrowUpIcon = function SvgTransferArrowUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#027680",
    fillRule: "evenodd",
    d: "M11.375 0C5.093 0 0 5.093 0 11.375S5.093 22.75 11.375 22.75 22.75 17.657 22.75 11.375 17.657 0 11.375 0m.619 6.381a.875.875 0 0 0-1.238 0l-3.5 3.5a.875.875 0 1 0 1.238 1.238L10.5 9.112v6.638a.875.875 0 1 0 1.75 0V9.112l2.006 2.007a.875.875 0 1 0 1.238-1.238z",
    clipRule: "evenodd"
  })));
};
export { SvgTransferArrowUpIcon as ReactComponent };
export default __webpack_public_path__ + "9f5270a61920773f99750bbd478ac2fe.svg";